import { z } from 'zod';

/** Classifier output for one Sentry issue. */
export const SentryTriageSchema = z.object({
  classification: z.enum(['noise', 'transient', 'needs_fix', 'dangerous']),
  userImpact: z.enum(['none', 'degraded', 'blocked', 'data_or_security']),
  reason: z.string(),
  title: z.string().trim().min(1).max(120),
  linearProject: z.string().nullable(),
});

export type SentryTriageResult = z.infer<typeof SentryTriageSchema>;
